import { useRouter } from "next/router";
import React, { useEffect } from "react";

import { Loader } from "~/components/ui/loader";
import { useAuth } from "~/contexts/providers/auth";
import { UserStatus } from "~/types/auth/userEnums.types";
import { HOME_PAGE } from "~/utils/pages";

import styles from "./index.module.scss";

const UnauthenticatedPage: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (user?.id && user.status === UserStatus.VALIDATED)
      router.push(`${HOME_PAGE}`);
  }, [router, user]);

  if (!(user?.id && user.status === UserStatus.VALIDATED))
    return <>{children}</>;

  return (
    <div className={styles.container}>
      <Loader />
    </div>
  );
};

export default UnauthenticatedPage;
